import React, { useState } from 'react';
import {
    useCreateMappingMutation,
    useGetMappingListQuery,
    useSwitchLabelMutation,
    useDeleteLabelMutation,
    useCreateLabelMutation,
    useSwitchLabelParentMutation
} from '../../app/stageMappingApi/stageMappingApi';

import Button from '../../components/shared/buttons/button';
import { showToast } from '../../helpers/Utils';
import { Image } from 'react-bootstrap';
import UpdateStageMappingModal from '../../components/shared/modalContent/UpdateStageMappingModal';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { RiDragMoveFill } from "react-icons/ri";
import { MdOutlineEditNote, MdDeleteOutline } from "react-icons/md";
import './stagemapping.css';
import CommonDeleteModal from '../../components/shared/modalContent/CommonDeleteModal';

const StageMapping = () => {
    const [page] = useState(1);
    const [showUpdateStageMappingModal, setShowUpdateStageMappingModal] = useState(false);
    const [stageId, setStageId] = useState(null);
    const [dragData, setDragData] = useState(null); // { type, id, fromLabelId? }
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const { data: getMappingList } = useGetMappingListQuery({ page });
    const [switchLabel] = useSwitchLabelMutation();
    const [switchLabelParent] = useSwitchLabelParentMutation();
    const [createMapping, { isLoading }] = useCreateMappingMutation();
    const [createLabel, { isLoading: isLabeling }] = useCreateLabelMutation();
    const [deleteSurvey, { isLoading: isDeleting }] = useDeleteLabelMutation();

    const handleDragStart = ({ type, id, fromLabelId = null }) => {
        setDragData({ type, id, fromLabelId });
    };

    const handleDrop = async (toLabelId) => {
        if (!dragData || dragData.id === toLabelId) return;

        try {
            if (dragData.type === 'stage') {
                await switchLabel({
                    body: {
                        stageId: dragData.id,
                        fromlabelId: dragData.fromLabelId,
                        toLabelId,
                    }
                }).unwrap();
            } else if (dragData.type === 'label') {
                await switchLabelParent({
                    body: {
                        fromLabelId: dragData.id,
                        toLabelId,
                    }
                }).unwrap();
            }
        } catch (error) {
            showToast(error?.data?.message || "Failed to move");
        } finally {
            setDragData(null);
        }
    };

    const handleSyncMapping = async () => {
        try {
            await createMapping().unwrap();
        } catch (error) {
            showToast(error?.data?.message || "Something went wrong");
        }
    };

    const HandleCreateLabel = async () => {
        try {
            await createLabel().unwrap();
        } catch (error) {
            showToast(error?.data?.message || "Something went wrong");
        }
    };

    const handleDelete = async () => {
        try {
            await deleteSurvey({ stageId }).unwrap();
            setShowDeleteModal(false);
        } catch (error) {
            showToast(error?.data?.message || "Failed to delete");
        }
    };

    return (
        <div>
            <CommonDeleteModal
                show={showDeleteModal}
                setShow={setShowDeleteModal}
                onSucces={handleDelete}
                title="Are you sure you want to delete label"
            />
            <UpdateStageMappingModal
                show={showUpdateStageMappingModal}
                setShow={setShowUpdateStageMappingModal}
                stageId={stageId}
            />

            <div className='d-flex gap-3 mb-3'>
                <h2 className='cmn_heading flex-grow-1'>Stage Mapping</h2>
                <Button label={isLoading ? "Syncing..." : "Sync Mapping"} onClick={handleSyncMapping} />
                <Button label={isLabeling ? "Creating..." : "Create label"} onClick={HandleCreateLabel} />
            </div>

            <div className='d-flex gap-2 flex-column stagingCard-wrapper'>
                {getMappingList?.data?.data?.map((label, index) => (
                    <div
                        key={index}
                        className='stagingCard position-relative'
                        draggable
                        onDragStart={() => handleDragStart({ type: 'label', id: label._id })}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={() => handleDrop(label._id)}
                    >
                        <div className='d-flex gap-3'>
                            <PhotoProvider>
                                <PhotoView src={label?.label_image || '/images/dummy-image.png'}>
                                    <Image
                                        src={label?.label_image || '/images/dummy-image.png'}
                                        width='40'
                                        height='40'
                                        className='object-fit-cover rounded-5'
                                    />
                                </PhotoView>
                            </PhotoProvider>
                            <div className='w-100'>
                                <div className='d-flex gap-2 align-items-center'>
                                    <h6 className='flex-grow-1'>{label?.label}</h6>
                              {label?.label !== "Hidden"  &&(  <>
                                 
                                  <MdOutlineEditNote
                                        className='hightlight cursor-pointer'
                                        onClick={() => {
                                            setStageId(label._id);
                                            setShowUpdateStageMappingModal(true);
                                        }}
                                        size={22}
                                    />
                                    <MdDeleteOutline
                                        onClick={() => {
                                            setStageId(label._id);
                                            setShowDeleteModal(true);
                                        }}
                                        className='hightlight cursor-pointer'
                                        size={22}
                                    />
                                 </>)  }
                                </div>
                                <p>{label?.description}</p>
                                <ul className='m-0 p-0 d-flex gap-2 flex-wrap'>
                                    {label?.stages?.map((stage, stageIndex) => (
                                        <li
                                            key={stageIndex}
                                            className='d-flex gap-2 justify-content-between align-items-center'
                                            draggable
                                            onDragStart={(e) => {
                                                e.stopPropagation();
                                                handleDragStart({ type: 'stage', id: stage.id, fromLabelId: label._id });
                                            }}
                                            onDrop={(e) => e.stopPropagation()} // optional, for safety
                                        >
                                            <span>{stage?.name}</span>
                                            <RiDragMoveFill />
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default StageMapping;
